import errorErrorLogsHandler from "../../services/ErrorLogs";

export default {
    async loadErrorLogs({commit, dispatch}, payload) {
        const {data} = await errorErrorLogsHandler.all(payload);

        commit('SET_ERROR_LOGS', data);
    }
}
